import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import vuetify from './plugins/vuetify';
//import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
//import axios from "axios";
//import { desofuscarJSON } from '../../cliente-comun/utilidades'
import MixinRoot from '../../cliente-comun/mixins/root'

Vue.config.productionTip = false


/*var firebaseConfig = {
	apiKey: "AIzaSyB6dUXTGGN7cxgWV7an4_BPMrz-0Eg2R7o",
	//authDomain: "restaurantes-c2df2.firebaseapp.com",
	databaseURL: "https://restaurantes-c2df2.firebaseio.com",
	projectId: "restaurantes-c2df2",
	storageBucket: "restaurantes-c2df2.appspot.com",
	messagingSenderId: "840398364086",
	appId: "1:840398364086:web:4e518e4c03d720671df517"
};*/

new Vue({
  router,
  vuetify,
	render: h => h(App),
	data: () => ({
		/*axios: null,
		accesoInicialCargado: false,
		datos: {
			id: '',
			nombre: '',
			acceso: {
				restaurante: '',
				código: '',
			}
		},
		firestore: null,
		modo: 'DESARROLLO'*/
	}),
	mixins: [MixinRoot],
	/*watch: {
		'datos': {
			handler: function() {
				this.axios.defaults.headers.common['X-Restaurante-ID'] = this.datos ? this.datos.id : ''
				this.axios.defaults.headers.common['X-Restaurante-Codigo-De-Acceso'] = this.datos ? this.datos.acceso.código : ''
				this.axios.defaults.headers.common['X-Restaurante-Nombre-De-Acceso'] = this.datos ? this.datos.acceso.restaurante : ''
			},
			deep: true
		}
	},*/
	/*created: function () {
		console.log('Vuetify: ', this.$vuetify)
		firebase.initializeApp(firebaseConfig)
		this.firestore = firebase.firestore()

		this.axios = axios.create({
			baseURL: 'https://us-central1-restaurantes-c2df2.cloudfunctions.net/api/v1/servicio',
			timeout: 30000,
			//headers: {'X-Custom-Header': 'foobar'}
		});

		this.accesoInicial()
	},*/
	methods: {
		/*accesoInicial: function() {
			let v = localStorage.getItem('restaurantes.servicio')
			if (!v) {
				this.accesoInicialCargado = true
				return
			}

			//let d = this.desofuscarJSON(v)
			let d = desofuscarJSON(v)
			if (!d) {
				this.accesoInicialCargado = true
				return
			}

			this.axios.post('/acceso', d.acceso).then(rta => {
				this.datos = d
				this.accesoInicialCargado = true
			}).catch(err => {
				this.accesoInicialCargado = true
			})
		},
		cerrarSesión: function() {
			this.datos = null
			localStorage.removeItem('restaurantes.servicio')
		},*/
		/*ofuscarJSON: function (o) {
			if (o === null || o === undefined) {
				return ''
			}

			let s = JSON.stringify(o)
			let b = btoa(encodeURIComponent(s))
			let l = b.length

			if (l < 10) {
				return s
			}

			let i = b.substr(0, 7)
			let f = b.substr(l - 3)

			let n = b.replace(new RegExp('^' + i), '')
			n = n.replace(new RegExp(f + '$'), '')

			return n + 'yQ' + i + 'zP' + f
		},
		desofuscarJSON: function (n) {
			if (!n) {
				return
			}

			let l = n.length

			if (l < 10) {
				return JSON.parse(atob(n))
			}

			let i = n.substr(l - 12, 7)
			let f = n.substr(l - 3)

			let b = i + n.replace(new RegExp('yQ' + i + 'zP' + f + '$'), f)

			let s = decodeURIComponent(atob(b))

			return JSON.parse(s)
		},*/
		/*actualizarListadoDesdeFirestore: function(listado, change) {
			let obj = Object.assign({'id': change.doc.id}, change.doc.data())
			if (change.type === "added") {
					listado.push(obj)
			} else if (change.type === "modified") {
					for (let i in listado) {
						if (listado[i].id == change.doc.id) {
							this.$set(listado, i, obj)
							break
						}
					}
			} else if (change.type === "removed") {
					let idx = -1
					for (let i in listado) {
						if (listado[i].id == change.doc.id) {
							idx = i
							break
						}
					}
					listado.splice(idx, 1)
			}

			return obj
		},*/
		/*númeroEnLetrasYTextoConcordante: function(n, unx, ts, tp) {
			let t = n === 1 ? ts : tp
			let obj = {'n': '', 't': t}
			if (n === 1) {
				obj.n = unx
			} else if (n === 2) {
				obj.n = 'dos'
			} else if (n === 3) {
				obj.n = 'tres'
			} else if (n === 4) {
				obj.n = 'cuatro'
			} else if (n === 5) {
				obj.n = 'cinco'
			} else if (n === 6) {
				obj.n = 'seis'
			} else if (n === 7) {
				obj.n = 'siete'
			} else if (n === 8) {
				obj.n = 'ocho'
			} else if (n === 9) {
				obj.n = 'nueve'
			} else if (n === 10) {
				obj.n = 'diez'
			} else if (n === 11) {
				obj.n = 'once'
			} else if (n === 12) {
				obj.n = 'doce'
			} else {
				obj.n = n
			}

			return obj
		},
		idAleatorio: function(l) {
			let r = ''
			let c = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
			let L = c.length;
			for ( let i = 0; i < l; i++ ) {
					r += c.charAt(Math.floor(Math.random() * L))
			}
			return r
		},
		mayúsculaInicial: function(t) {
			let I = (t || '').substr(0,1).toUpperCase()
			return (t || '').replace(/^[a-zA-Z]/, I)
		}*/
	}
}).$mount('#app')
